import React from "react";
import {
  RotaTable,
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
  RotaButtonIcon,
  iconNew
} from "@teamrota/rota-design";

import { EmptyText } from "~/src/components/payroll/style";
import { PayrollRule } from "./types";
import { formatDateFull } from "~/src/utils/formatting";

const { Edit, Info } = iconNew;

type TableProps = {
  payrollRules: PayrollRule[];
  handleOpenRule: (id: string) => void;
  canEdit: boolean;
};

const Table = ({ payrollRules, handleOpenRule, canEdit }: TableProps) => {
  return (
    <RotaTable>
      <THead>
        <TrHead>
          <Th>Name</Th>
          <Th>User</Th>
          <Th>Created at</Th>
          <Th>Last edited</Th>
          <Th>Action</Th>
        </TrHead>
      </THead>

      <TBody>
        {payrollRules?.length ? (
          payrollRules.map((rule: PayrollRule) => (
            <Tr key={rule.id}>
              <Td>
                <InnerCell>{rule.name}</InnerCell>
              </Td>
              <Td>
                <InnerCell>USER</InnerCell>
              </Td>
              <Td>
                <InnerCell>{formatDateFull(rule.createdAt)}</InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  {rule.updatedAt && formatDateFull(rule.updatedAt)}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  <RotaButtonIcon
                    onClick={() => handleOpenRule(rule.id)}
                    style={{ margin: "auto" }}
                  >
                    {canEdit ? <Edit /> : <Info />}
                  </RotaButtonIcon>
                </InnerCell>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={5}>
              <EmptyText>Nothing to see here 👀 Try clicking Create!</EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </RotaTable>
  );
};

export default Table;
